import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useJobCatalogTreeVisibility } from 'modules/job_catalog/hooks/useJobCatalogTreeVisibility'
import {
  NODE_TYPES,
  getNavigationForTypeFromFunction,
  getNodeTypeFromParams,
} from 'modules/job_catalog/lib/nodesUtils'

const NodeRedirectPage = () => {
  const { navigation } = useNavigation()

  const { rootId, familyId, functionId, roleId, levelId } = useParams()

  const nodeType = getNodeTypeFromParams({ familyId, functionId, roleId, levelId })
  const nav = getNavigationForTypeFromFunction(navigation, nodeType)

  const { canSeeCompetencies } = useJobCatalogTreeVisibility()

  const getRedirectPath = () => {
    if (nodeType !== NODE_TYPES.LEVEL) return nav.overview
    if (canSeeCompetencies) return nav.competencies
    return nav.workingConditions
  }

  return (
    <Navigate
      replace
      to={{
        pathname: getRedirectPath().fullPath({
          rootId: rootId ?? '',
          familyId: familyId ?? '',
          functionId: functionId ?? '',
          roleId: roleId ?? '',
          levelId: levelId ?? '',
        }),
      }}
    />
  )
}

export default NodeRedirectPage
